module.exports = __webpack_public_path__ + "img/show_cn_text_3.1b3d7b07.png";